var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showBtns &&
      _vm.geolocationMessage.errorCode !== 612 &&
        _vm.errorMsgLocalStorage !== "612"
        ? _c(
            "div",
            {
              staticClass: "betSlipBtns",
              class: [
                _vm.currentBetSlipStateName,
                {
                  isFastBet: _vm.isFastBet,
                  bet_placed: _vm.betSlipStatus.State == 2
                }
              ]
            },
            [
              _vm.betsNo || _vm.isLoggedIn
                ? _c(
                    "div",
                    {
                      staticClass: "action-btns",
                      class: [
                        _vm.currentBetSlipStateName,
                        { inRefferal: _vm.inRefferal }
                      ]
                    },
                    [
                      _vm.currentBetSlipState == 0 &&
                      _vm.betsNo &&
                      !_vm.isFastBet &&
                      _vm.betslipLayout2 &&
                      _vm.brandLayout === "generic"
                        ? _c(
                            "div",
                            {
                              staticClass: "betslip_total_cost betslipLayout2"
                            },
                            [
                              _c("div", [
                                _c("div", { staticClass: "line1" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("BetSlip.btn.PlaceBet.TotalCost")
                                      ) + ":"
                                    )
                                  ]),
                                  _vm._v(
                                    "  " +
                                      _vm._s(
                                        _vm._f("currency")(
                                          this.betSlipTotals.totalStake
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ]),
                                _vm._v(" "),
                                !_vm.showBetSlipChanged &&
                                _vm.discount &&
                                _vm.discount > 0 &&
                                !_vm.appliedSOvoucherDescription
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "voucher-data voucher-data-1"
                                      },
                                      [
                                        _c("div", { staticClass: "voucher" }, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "BetSlip.promotions.totalDiscount"
                                                )
                                              ) + ":"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "discount" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("currency")(
                                                    _vm.discount
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _vm.discount > 0 &&
                                        !_vm.appliedSOvoucherDescription
                                          ? _c(
                                              "div",
                                              { staticClass: "actual-stake" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "BetSlip.btn.PlaceBet.TotalCost.Discounted"
                                                      )
                                                    ) + ":"
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "discount" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("currency")(
                                                          this.betSlipTotals
                                                            .totalStake -
                                                            1 *
                                                              _vm.discount.toFixed(
                                                                2
                                                              )
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.showBetSlipChanged &&
                                _vm.discount &&
                                _vm.discount < 0.01 &&
                                _vm.appliedSOvoucherDescription
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "voucher-data voucher-data-2"
                                      },
                                      [
                                        _c("div", { staticClass: "voucher" }, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "BetSlip.promotions.used"
                                                )
                                              ) + ":"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "discount" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.appliedSOvoucherDescription
                                                )
                                              )
                                            ]
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showSOBonusOnReceipt &&
                                (_vm.betSlipTotals.soParlayBoost ||
                                  (_vm.betSlipTotals.boostNames &&
                                    _vm.betSlipTotals.boostNames.length))
                                  ? _c("div", { staticClass: "line-bonus" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "BetSlip.receipt.bonus.potential"
                                            )
                                          )
                                        ),
                                        _vm.showSOBonusNameOnReceipt &&
                                        _vm.betSlipTotals.boostNames &&
                                        _vm.betSlipTotals.boostNames.length
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                (" +
                                                  _vm._s(
                                                    _vm.betSlipTotals.boostNames.join(
                                                      ", "
                                                    )
                                                  ) +
                                                  ")"
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(":")
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("currency")(
                                              _vm.betSlipTotals.soParlayBoost
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "line2" }, [
                                  _c("span", [
                                    !_vm.betSlipTotals.soParlayBoost
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "BetSlip.btn.PlaceBet.TotalPotentialReturn"
                                              )
                                            ) + ":"
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.betSlipTotals.soParlayBoost &&
                                    _vm.showWinningInclBonus
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "BetSlip.btn.PlaceBet.TotalPotentialReturn"
                                              )
                                            ) +
                                              " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "BetSlip.receipt.bonus.included"
                                                )
                                              ) +
                                              ":"
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.betSlipTotals.soParlayBoost &&
                                    !_vm.showWinningInclBonus
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "BetSlip.btn.PlaceBet.TotalPotentialReturn"
                                              )
                                            ) +
                                              " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "BetSlip.receipt.bonus.notIncluded"
                                                )
                                              ) +
                                              ":"
                                          )
                                        ])
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("currency")(
                                          _vm.betSlipTotals.winning +
                                            (_vm.betSlipTotals.soParlayBoost &&
                                            _vm.showWinningInclBonus
                                              ? _vm.betSlipTotals.soParlayBoost
                                              : 0)
                                        )
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _vm.showSOInsuranceOnReceipt &&
                                _vm.betSlipTotals.insurance &&
                                _vm.betSlipTotals.insurance.length
                                  ? _c(
                                      "div",
                                      { staticClass: "line-insurance" },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "SpecialOffer.PARLAYINSURANCE.eligible"
                                              )
                                            ) + "\n                "
                                          ),
                                          _vm.showSOInsuranceNameOnReceipt
                                            ? _c("span", [
                                                _vm._v(
                                                  "(" +
                                                    _vm._s(
                                                      _vm.betSlipTotals.insurance.join(
                                                        ", "
                                                      )
                                                    ) +
                                                    ")"
                                                )
                                              ])
                                            : _vm._e()
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.betslipLayout2 && _vm.brandTemplate === "generic_2"
                        ? [
                            _vm.currentBetSlipState == 0 &&
                            _vm.betsNo &&
                            !_vm.isFastBet
                              ? _c(
                                  "div",
                                  { staticClass: "odds_movements" },
                                  [
                                    _vm.isLoggedIn &&
                                    _vm.betsNo &&
                                    _vm.currentBetSlipState < 2
                                      ? _c("preference-switch", {
                                          attrs: {
                                            id: "showAcceptingChangesInfo",
                                            currentBetSlipState:
                                              _vm.currentBetSlipState
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.betsNo && !_vm.isLoggedIn
                        ? _c("div", [
                            _vm.currentBetSlipState == 9
                              ? _c("div", { staticClass: "align-center" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "v-btn secondary btn_blue",
                                      on: {
                                        click: function($event) {
                                          return _vm.dismissBetSlip(1, 1, 0)
                                        }
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("BetSlip.placement.btn.OK")
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentBetSlipState != 9 && _vm.betsNo
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "align-center btn-container",
                                    class: { withSaveBet: _vm.isWishBetEnabled }
                                  },
                                  [
                                    _vm.isFastBet
                                      ? _c(
                                          "div",
                                          { staticClass: "column column-left" },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass: "v-btn btn_white",
                                                attrs: {
                                                  disabled:
                                                    _vm.currentBetSlipState > 0
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.confirmDialog()
                                                  }
                                                }
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "BetSlip.quick.btn.addToBetSlip"
                                                      )
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.isFastBet && _vm.isWishBetEnabled
                                      ? _c(
                                          "div",
                                          { staticClass: "column column-left" },
                                          [
                                            _vm.wishBetInProgress
                                              ? _c(
                                                  "div",
                                                  [_c("dots-loader")],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass: "v-btn",
                                                class: [
                                                  _vm.isReadOnly
                                                    ? "primary-btn"
                                                    : "btn_white",
                                                  "wbbtn-disabled-" +
                                                    (_vm.wishBetSaveBtnDisabled
                                                      ? _vm.wishBetSaveBtnDisabled
                                                      : "Not")
                                                ],
                                                attrs: {
                                                  id: "btnSaveBet",
                                                  disabled:
                                                    _vm.wishBetSaveBtnDisabled
                                                },
                                                on: { click: _vm.storeWishBet }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    key:
                                                      "betsCnt-" + _vm.betsCnt
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "BetSlip.btn.msg.SaveBet" +
                                                            (_vm.betsCnt &&
                                                            _vm.betsCnt > 1
                                                              ? "s"
                                                              : ""),
                                                          { n: _vm.betsCnt }
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.isReadOnly
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "column column-right"
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "v-btn primary-button primary-btn yellow-btn",
                                                attrs: {
                                                  id: "btnPlaceBetNotLoggedIn"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.popLogIn()
                                                  }
                                                }
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "BetSlip.btn.msg.LogIn"
                                                      )
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isLoggedIn
                        ? _c("div", [
                            _vm.currentBetSlipState == 0
                              ? _c("div", [
                                  _vm.betsNo
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "align-center btn-container"
                                        },
                                        [
                                          _vm.isFastBet
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "column column-left"
                                                },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "v-btn btn_white",
                                                      attrs: {
                                                        disabled:
                                                          _vm.currentBetSlipState >
                                                          0
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.confirmDialog()
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "BetSlip.quick.btn.addToBetSlip"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "column column-right"
                                            },
                                            [
                                              !_vm.isFastBet &&
                                              !_vm.betslipLayout2
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "betslip_total_cost betslipLayout1"
                                                    },
                                                    [
                                                      _c("div", [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "line1"
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "BetSlip.btn.PlaceBet.TotalCost"
                                                                  )
                                                                ) + ":"
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              "  " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "currency"
                                                                  )(
                                                                    this
                                                                      .betSlipTotals
                                                                      .totalStake
                                                                  )
                                                                ) +
                                                                "\n                    "
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        !_vm.showBetSlipChanged &&
                                                        _vm.discount &&
                                                        _vm.discount > 0 &&
                                                        !_vm.appliedSOvoucherDescription
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "voucher-data voucher-data-3"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "voucher"
                                                                  },
                                                                  [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "BetSlip.promotions.totalDiscount"
                                                                          )
                                                                        ) + ":"
                                                                      )
                                                                    ]),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "discount"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm._f(
                                                                              "currency"
                                                                            )(
                                                                              _vm.discount
                                                                            )
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _vm.discount >
                                                                  0 &&
                                                                !_vm.appliedSOvoucherDescription
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "actual-stake"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "BetSlip.btn.PlaceBet.TotalCost.Discounted"
                                                                                )
                                                                              ) +
                                                                                ":"
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "discount"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm._f(
                                                                                  "currency"
                                                                                )(
                                                                                  this
                                                                                    .betSlipTotals
                                                                                    .totalStake -
                                                                                    1 *
                                                                                      _vm.discount.toFixed(
                                                                                        2
                                                                                      )
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        !_vm.showBetSlipChanged &&
                                                        _vm.discount &&
                                                        _vm.discount < 0.01 &&
                                                        _vm.appliedSOvoucherDescription
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "voucher-data voucher-data-4"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "voucher"
                                                                  },
                                                                  [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "BetSlip.promotions.used"
                                                                          )
                                                                        ) + ":"
                                                                      )
                                                                    ]),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "discount"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.appliedSOvoucherDescription
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.showSOBonusOnReceipt &&
                                                        (_vm.betSlipTotals
                                                          .soParlayBoost ||
                                                          (_vm.betSlipTotals
                                                            .boostNames &&
                                                            _vm.betSlipTotals
                                                              .boostNames
                                                              .length))
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "line-bonus"
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "BetSlip.receipt.bonus.potential"
                                                                      )
                                                                    )
                                                                  ),
                                                                  _vm.showSOBonusNameOnReceipt &&
                                                                  _vm
                                                                    .betSlipTotals
                                                                    .boostNames &&
                                                                  _vm
                                                                    .betSlipTotals
                                                                    .boostNames
                                                                    .length
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "\n                        (" +
                                                                              _vm._s(
                                                                                _vm.betSlipTotals.boostNames.join(
                                                                                  ", "
                                                                                )
                                                                              ) +
                                                                              ")"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(":")
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "currency"
                                                                      )(
                                                                        _vm
                                                                          .betSlipTotals
                                                                          .soParlayBoost
                                                                      )
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "line2"
                                                          },
                                                          [
                                                            _c("span", [
                                                              !_vm.betSlipTotals
                                                                .soParlayBoost
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "BetSlip.btn.PlaceBet.TotalPotentialReturn"
                                                                        )
                                                                      ) + ":"
                                                                    )
                                                                  ])
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _vm.betSlipTotals
                                                                .soParlayBoost &&
                                                              _vm.showWinningInclBonus
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "BetSlip.btn.PlaceBet.TotalPotentialReturn"
                                                                        )
                                                                      ) +
                                                                        " " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "BetSlip.receipt.bonus.included"
                                                                          )
                                                                        ) +
                                                                        ":"
                                                                    )
                                                                  ])
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _vm.betSlipTotals
                                                                .soParlayBoost &&
                                                              !_vm.showWinningInclBonus
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "BetSlip.btn.PlaceBet.TotalPotentialReturn"
                                                                        )
                                                                      ) +
                                                                        " " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "BetSlip.receipt.bonus.notIncluded"
                                                                          )
                                                                        ) +
                                                                        ":"
                                                                    )
                                                                  ])
                                                                : _vm._e()
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "currency"
                                                                  )(
                                                                    _vm
                                                                      .betSlipTotals
                                                                      .winning +
                                                                      (_vm
                                                                        .betSlipTotals
                                                                        .soParlayBoost &&
                                                                      _vm.showWinningInclBonus
                                                                        ? _vm
                                                                            .betSlipTotals
                                                                            .soParlayBoost
                                                                        : 0)
                                                                  )
                                                                )
                                                              )
                                                            ])
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.showSOInsuranceOnReceipt &&
                                                        _vm.betSlipTotals
                                                          .insurance &&
                                                        _vm.betSlipTotals
                                                          .insurance.length
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "line-insurance"
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "SpecialOffer.PARLAYINSURANCE.eligible"
                                                                      )
                                                                    ) +
                                                                      "\n                        "
                                                                  ),
                                                                  _vm.showSOInsuranceNameOnReceipt
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "(" +
                                                                              _vm._s(
                                                                                _vm.betSlipTotals.insurance.join(
                                                                                  ", "
                                                                                )
                                                                              ) +
                                                                              ")"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ])
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ])
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.showBetSlipChanged
                                                ? _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "v-btn acceptChanges btn_blue",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.acceptChanges()
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "BetSlip.changed.btn.accept"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                : _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "v-btn primary-button primary-btn placebetbtn",
                                                      class: [
                                                        _vm.disablePlaceBet
                                                      ],
                                                      attrs: {
                                                        disabled:
                                                          _vm.disablePlaceBet ||
                                                          _vm.isButtonDisabled,
                                                        id: "btnPlaceBet"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.initPlaceBet()
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "btn-label"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value:
                                                                    _vm.gettingABTnR,
                                                                  expression:
                                                                    "gettingABTnR"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "loader-container"
                                                            },
                                                            [
                                                              _c(
                                                                "circle-loader"
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "BetSlip.btn.PlaceBet"
                                                                )
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentBetSlipState == 5
                              ? _c("div", { staticClass: "align-center" }, [
                                  !_vm.isFastBet && _vm.betSlipStatus.State == 2
                                    ? _c(
                                        "div",
                                        { staticClass: "action_buttons" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "column column-left"
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "v-btn secondary",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.dismissBetSlip()
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "BetSlip.btn.ReturnToBetting"
                                                        )
                                                      )
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "column column-right"
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass: "v-btn primary",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setTabFromBetSlip(
                                                        "HistoryActive"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "BetSlip.btn.ActiveBets"
                                                        )
                                                      )
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.betSlipStatus.State == 4
                                    ? _c("div", [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "v-btn bet_rejected",
                                            on: {
                                              click: function($event) {
                                                return _vm.dismissBetSlip(
                                                  1,
                                                  1,
                                                  0
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "BetSlip.placement.btn.OK"
                                                  )
                                                )
                                              )
                                            ])
                                          ]
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.betSlipStatus.State == 5 &&
                                  _vm.betSlipStatus.detailedStates &&
                                  _vm.betSlipStatus.detailedStates.indexOf(
                                    "referred"
                                  ) == -1
                                    ? _c("div", [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "v-btn btn_blue",
                                            on: {
                                              click: function($event) {
                                                return _vm.rejectBetSlip()
                                              }
                                            }
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "BetSlip.placement.btn.CANCEL"
                                                  )
                                                )
                                              )
                                            ])
                                          ]
                                        )
                                      ])
                                    : _vm._e()
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentBetSlipState == 6
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "align-center action_buttons"
                                  },
                                  [
                                    _vm.inRefferal
                                      ? _c(
                                          "div",
                                          { staticClass: "column column-left" },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass: "v-btn btn_white",
                                                attrs: {
                                                  disabled: _vm.isButtonDisabled
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.rejectBetSlip()
                                                  }
                                                }
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "BetSlip.placement.btn.CANCEL.reffer"
                                                      )
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.inRefferal
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "column column-right"
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "v-btn btn_green confirmreffer",
                                                class: {
                                                  inRefferal: _vm.inRefferal
                                                },
                                                attrs: {
                                                  disabled: _vm.isButtonDisabled
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.confirmBetSlip()
                                                  }
                                                }
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "BetSlip.placement.btn.CONFIRM.reffer"
                                                      )
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.inRefferal
                                      ? _c(
                                          "div",
                                          { staticClass: "column column-left" },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "v-btn btn_white confirmreffer",
                                                attrs: {
                                                  disabled: _vm.isButtonDisabled
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.confirmBetSlip()
                                                  }
                                                }
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "BetSlip.placement.btn.CONFIRM"
                                                      )
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.inRefferal
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "column column-right"
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "v-btn secondary btn_blue",
                                                attrs: {
                                                  disabled: _vm.isButtonDisabled
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.rejectBetSlip()
                                                  }
                                                }
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "BetSlip.placement.btn.CANCEL"
                                                      )
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentBetSlipState == 7
                              ? _c("div", { staticClass: "align-center" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "v-btn secondary btn_blue",
                                      on: {
                                        click: function($event) {
                                          return _vm.dismissBetSlip(1, 1, 0)
                                        }
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("BetSlip.placement.btn.OK")
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentBetSlipState == 8
                              ? _c("div", { staticClass: "align-center" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "v-btn secondary btn_blue",
                                      on: {
                                        click: function($event) {
                                          return _vm.dismissBetSlip(1, 1, 0)
                                        }
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("BetSlip.placement.btn.OK")
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentBetSlipState == 9
                              ? _c("div", { staticClass: "align-center" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "v-btn secondary btn_blue",
                                      on: {
                                        click: function($event) {
                                          _vm.dismissBetSlip(1, 1, 0)
                                          _vm.handle409()
                                        }
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("BetSlip.placement.btn.OK")
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                ])
                              : _vm._e()
                          ])
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              (_vm.brandLayout === "generic" || _vm.brandKey === "sb") &&
              !_vm.betsNo &&
              !_vm.isLoggedIn &&
              !_vm.isReadOnly
                ? _c("div", { staticClass: "action-btns emptybetslip" }, [
                    _c("div", [
                      _c("div", { staticClass: "align-center btn-container" }, [
                        _c("div", { staticClass: "column column-right" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "v-btn primary-button primary-btn yellow-btn",
                              attrs: { id: "btnPlaceBetLoggedIn" },
                              on: {
                                click: function($event) {
                                  return _vm.popLogIn()
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("BetSlip.btn.msg.LogIn")))
                              ])
                            ]
                          )
                        ])
                      ])
                    ])
                  ])
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("geolocation-indicator"),
      _vm._v(" "),
      !_vm.betslipLayout2
        ? [
            !_vm.mobileBigAndBelow
              ? _c("div", { staticStyle: { height: "10px" } })
              : _vm._e(),
            _vm._v(" "),
            _vm.currentBetSlipState == 0 && _vm.betsNo && !_vm.isFastBet
              ? _c(
                  "div",
                  { staticClass: "betslip_footer_bottom" },
                  [
                    _c(
                      "v-btn",
                      { staticClass: "delALL", on: { click: _vm.clearAll } },
                      [
                        _c("icon", { attrs: { name: "icon-trash-grey" } }),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("BetSlip.selection.btn.clearall")) +
                              " "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.isLoggedIn && _vm.betsNo && _vm.currentBetSlipState < 2
                      ? _c("preference-switch", {
                          attrs: {
                            id: "showAcceptingChangesInfo",
                            currentBetSlipState: _vm.currentBetSlipState
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.betslipLayout2 && _vm.brandTemplate !== "generic_2"
        ? [
            _vm.currentBetSlipState == 0 && _vm.betsNo && !_vm.isFastBet
              ? _c(
                  "div",
                  { staticClass: "betslip_footer_bottom" },
                  [
                    _vm.isLoggedIn && _vm.betsNo && _vm.currentBetSlipState < 2
                      ? _c("preference-switch", {
                          attrs: {
                            id: "showAcceptingChangesInfo",
                            currentBetSlipState: _vm.currentBetSlipState
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      { staticClass: "delALL", on: { click: _vm.clearAll } },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("BetSlip.selection.btn.clearall")) +
                              " "
                          )
                        ]),
                        _vm._v(" "),
                        _c("icon", { attrs: { name: "icon-trash-grey" } })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            "content-class": "dialog-betslip-confirm",
            persistent: "",
            fullscreen: false
          },
          model: {
            value: _vm.dialogBetslipConfirm.active,
            callback: function($$v) {
              _vm.$set(_vm.dialogBetslipConfirm, "active", $$v)
            },
            expression: "dialogBetslipConfirm.active"
          }
        },
        [
          _c("betslip-confirm", {
            attrs: { dialogBetslipConfirm: _vm.dialogBetslipConfirm }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d013ca86", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d013ca86","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslipV2/rootElements/buttons.vue
// module id = null
// module chunks = 